import { jsxs as C, jsx as n } from "react/jsx-runtime";
import O from "clsx";
import { FeeTable as a } from "./FeeTable.js";
import { j as t, k as c, C as P, S as G, G as p } from "./helpers-458d7e27.js";
import { i as x, T } from "./TextHeaderInner-7887aa3a.js";
import "react";
import "@emotion/react";
import "@paypalcorp/pp-react-theme";
import "@paypalcorp/pp-react-icons";
import "react-dom";
import "./TextGroup-dd19925e.js";
import "./AppDownload-79ac7787.js";
import "./pp-react-text-input.esm-853a9847.js";
import "./card-renderer-3ad4b108.js";
import "./PpReactCurrencyInput-cfa9b61d.js";
const w = () => {
  const s = {
    start: 1,
    span: 7
  }, e = {
    lgOptions: {
      columnStart: t.leftInner,
      columnEnd: t.rightInner
    },
    options: {
      columnStart: t.leftEdge,
      columnEnd: t.rightEdge
    }
  };
  return {
    textCol: s,
    tableCol: e
  };
}, F = {
  options: {
    columnStart: t.leftOuter,
    columnEnd: t.rightOuter
  },
  lgOptions: {
    columnStart: t.leftInner,
    columnEnd: t.rightInner
  }
}, _ = {
  options: {
    columnStart: t.leftOuter,
    columnEnd: t.rightOuter
  },
  lgOptions: {
    columnStart: t.leftInner,
    columnEnd: c.mid
  }
}, j = {
  options: {
    columnStart: t.leftOuter,
    columnEnd: t.rightOuter
  },
  lgOptions: {
    columnStart: c.mid,
    columnEnd: t.rightInner
  }
};
const i = "FeeTableSection", r = new P(i), v = ({
  componentId: s = "fee-table-section",
  textGroup: e,
  tables: o,
  disclosure: d,
  topSpacer: u = "2vw",
  bottomSpacer: g = "2vw"
}) => {
  const I = O(
    r.componentName,
    r.getElementClassName("wrapper")
  ), N = r.getElementClassName("tableGrid"), S = {
    topSpacing: u,
    bottomSpacing: g,
    rowsGap: "default",
    rowsMinHeight: "0"
  }, f = w();
  let m = e;
  return e && !x(e) && (m = {
    ...f.textCol,
    textGroup: {
      ...e
    }
  }), /* @__PURE__ */ C(
    G,
    {
      className: I,
      options: S,
      disclosure: d,
      id: s,
      theme: "white",
      children: [
        e && /* @__PURE__ */ n(
          T,
          {
            ...m,
            textGroup: {
              ...m.textGroup,
              className: r.getElementClassName("text-group"),
              analyticsCompName: i
            }
          }
        ),
        (o == null ? void 0 : o.length) === 1 ? /* @__PURE__ */ n(p, { ...F, children: /* @__PURE__ */ n(a, { ...o[0], theme: null }) }) : o == null ? void 0 : o.map((l, h) => {
          const E = h % 2 ? j : _;
          return /* @__PURE__ */ n(
            p,
            {
              ...E,
              className: N,
              children: /* @__PURE__ */ n(a, { ...l, theme: null })
            },
            `${l.caption}`
          );
        })
      ]
    }
  );
};
v.displayName = i;
export {
  v as default
};
//# sourceMappingURL=FeeTableSection.js.map
